export default __webpack_public_path__ + "static/media/4.d1903908.png";